import { motion } from 'framer-motion';
import { useId, ChangeEvent, HTMLAttributes } from 'react';
import { LiaTimesCircle } from 'react-icons/lia';
import { RiSearchLine } from 'react-icons/ri';

import { cn, ONLY_LETTERS } from '@/utils';
import { FADE_IN_OUT, inputTextBaseClass } from '@/utils/constants';

interface SharedProps {
  error?: string;
  label?: string;
  success?: boolean;
  pattern?: string;
}

export interface InputSearchProps
  extends SharedProps,
    HTMLAttributes<HTMLInputElement> {
  name: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  placeholder: string;
  handleCancel: () => void;
  onlyLetters?: boolean;
}

const InputSearch = ({
  name,
  value,
  disabled,
  placeholder,
  handleCancel,
  onChange,
  onlyLetters,
}: InputSearchProps) => {
  const id = useId();
  const alertId = useId();

  const idLabelFor = `search-input-${id}`;

  const inputClass = cn(inputTextBaseClass, 'pl-[40px]', {
    'text-gdt-gray-4 border-gdt-gray-5 bg-gdt-gray-6': disabled,
    'pr-[90px] ': value.length > 0,
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onlyLetters) {
      if (ONLY_LETTERS.test(e.target.value) || e.target.value === '') {
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  return (
    <motion.div animate={'show'} initial={'hide'} variants={FADE_IN_OUT}>
      <fieldset className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <RiSearchLine
            className={cn('text-gdt-blue w-5 h-5', {
              'opacity-20': disabled,
            })}
          />
        </div>
        <input
          aria-describedby={alertId}
          aria-invalid="false"
          aria-label="Ingresa tu busqueda acá"
          aria-labelledby={id}
          className={inputClass}
          disabled={disabled}
          id={idLabelFor}
          name={name}
          placeholder={placeholder}
          title="Busqueda general"
          type="text"
          value={value}
          onChange={handleInputChange}
        />
        {value.length > 0 && (
          <button
            className="absolute inset-y-0 right-0 flex items-center gap-1 pr-3"
            type="button"
            onClick={handleCancel}
          >
            <div>
              <LiaTimesCircle className="w-5 h-5 text-gdt-gray-5" />
            </div>
            <span className="inline-block text-gdt-gray-4 text-2xs">
              Cancelar
            </span>
          </button>
        )}
      </fieldset>
    </motion.div>
  );
};

export default InputSearch;
